<template>
  <div class="notification is-warning">
    <label v-if="title" class="label notification__title">{{ title }}</label>
    {{ notes }}
  </div>
</template>

<script>
export default {
  props: {
    notes: String,
    title: String,
  },
};
</script>
